import { useCallback, useRef } from 'react';
import { useEventListener } from '../useEventListener';
export const useOnClickOutside = ({ ref, callback, }) => {
    const onClickOutsideListener = useCallback((event) => {
        if (!ref?.current || ref?.current?.contains(event.target)) {
            return;
        }
        callback(event);
    }, [ref, callback]);
    const documentRef = useRef(document.body);
    useEventListener({
        eventName: 'click',
        ref: documentRef,
        callback: onClickOutsideListener,
        capture: true,
    });
    useEventListener({
        eventName: 'touchend',
        ref: documentRef,
        callback: onClickOutsideListener,
        capture: true,
    });
};
//# sourceMappingURL=index.js.map